import {
  Fragment,
  Suspense,
  lazy,
} from 'react';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import LoadingScreen from 'components/LoadingScreen';
import PermissionGuard from 'components/PermissionGuard';

import authenticationRoutes from './authentication';
import dashboardRoutes from './dashboard';
import requestRoutes from './request';
import termsAndConditions from './terms_and_conditions';
import privacyNotice from './privacy_notice';

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, index) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;

          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes
                      ? (renderRoutes(route.routes))
                      : (route.permission
                        ? (<PermissionGuard permission={route.permission}>
                          <Component {...props} />
                        </PermissionGuard>)
                        : (<Component {...props} />))}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense >
  ) : null;

function Routes() {
  return renderRoutes([
    {
      exact: true,
      path: '/',
      component: () => <Redirect to="/request" />,
    },
    authenticationRoutes,
    dashboardRoutes,
    requestRoutes,
    termsAndConditions,
    privacyNotice,
    {
      component: lazy(() => import('views/Errors/Error404')),
    },
  ]);
}

export default Routes;
